module.exports = "is_responsible"